import {
    AbstractPluginsModule,
    DatatablesModule,
    FormsModule,
    QuickAdditService,
    SupportModule
} from '@kaiser-software/chassis-core';
import { NgModule } from '@angular/core';
import { AddressService } from './services/address.service';
import { RelationAddressService } from './services/relation-address.service';
import { AddressFormComponent } from './components/address-form/address-form.component';
import { AddressRelationPlugin } from './plugins/address-relation/address-relation.plugin';
import { AddressesRoutingModule } from './addresses-routing.module';
import { AddressRelationListItem } from './plugins/address-relation/item/address-relation.list-item';

@NgModule({
    imports: [
        FormsModule,
        DatatablesModule,
        SupportModule,
        AbstractPluginsModule,
        AddressesRoutingModule
    ],
    declarations: [
        AddressFormComponent,
        AddressRelationPlugin,
        AddressRelationListItem
    ],
    entryComponents: [
        AddressFormComponent,
        AddressRelationPlugin,
        AddressRelationListItem
    ],
    providers: [
        AddressService,
        RelationAddressService,
    ],
    exports: [
        AddressFormComponent,
        AddressRelationPlugin,
    ]
})
export class AddressesModule {

    public constructor(protected quickAdditService: QuickAdditService) {

        quickAdditService
            .register('address', AddressService);

        // .tabs((tab: QuickAdditTabManager) => {
        //     tab.add('Images', 'images');
        // })
        // .plugins((plugin: PluginProxy) => {
        //     plugin.add('images', 'images-plugin', )
        // });

    }

}



// WEBPACK FOOTER //
// ./libs/donna-core/src/app/addresses/addresses.module.ts